import type { Tokens } from '../augmentation'
import { spacing } from '../spacing'
import { type ComponentCreation } from './types'

export const createMuiBadge = ({ palette, typography }: Pick<Tokens, 'palette' | 'typography'>): ComponentCreation =>
  ({
    MuiBadge: {
      styleOverrides: {
        root: {
          '&.DhlBadgeInline > .MuiBadge-badge': {
            transform: 'inherit',
            transformOrigin: 'inherit',
            position: 'relative',
          },
        },
        badge: {
          ...typography.caption1,
          padding: 0,

          '&:not(:has(button.MuiButtonBase-root))': {
            padding: spacing(0, 0.5),
          },
        },
      },
      variants: [
        {
          props: { color: 'default' },
          style: {
            '.MuiBadge-badge': {
              backgroundColor: palette.dark.light,
            },
          },
        },
        {
          props: { variant: 'dot' },
          style: {
            '.MuiBadge-dot': {
              height: spacing(1),
              minWidth: spacing(1),
              borderRadius: '50%',
            },
          },
        },
        {
          props: { variant: 'standard' },
          style: {
            '.MuiBadge-standard': {
              height: spacing(2.5),
              minWidth: spacing(2.5),
              borderRadius: spacing(1.25),
            },
          },
        },
      ],
    },
  }) satisfies ComponentCreation
